import { fieldConfig } from "@autoform/zod";
import * as z from "zod";
import { zColor } from "../common/schemaHelpers";

const PRIMARY_FONTS = ["Manrope", "Helvetica", "peridot-pe-variable", "Roboto", "AzoSansWeb", "TeleNeo"] as const;

const SECONDARY_FONTS = ["Thicker", "Iliad", "BTCosmoBold", "Roboto", "AzoSansWeb", "TeleNeo"] as const;

export const themeShape = {
	brandColor: zColor().default("#1A1A1A").describe("Brand Color"),
	iconColor: zColor().optional().describe("Icon Color"),
	iconLineColor: z
		.enum(["white", "black"])
		.default("white")
		.check(fieldConfig({ fieldType: "singleselect" }))
		.describe("Icon Line Color"),
	buttonColor: zColor().optional().describe("Button Color"),
	navbarColor: zColor().default("#F2F2F2").describe("Navbar Color"),
	navbarNegativeColor: zColor().optional().describe("Navbar Negative Color"),
	poweredByPandas: z.boolean().default(true).describe("Powered by Pandas"),
	buttonBorderRadius: z.string().default("6.25rem").describe("Button Border Radius"),
	primaryFonts: z
		.enum(PRIMARY_FONTS)
		.optional()
		.check(fieldConfig({ fieldType: "singleselect" }))
		.describe("Primary Font"),
	secondaryFonts: z
		.enum(SECONDARY_FONTS)
		.optional()
		.check(fieldConfig({ fieldType: "singleselect" }))
		.describe("Secondary Font"),
};

export const themeSchema = z.object(themeShape);

export type ThemeConfig = z.infer<typeof themeSchema>;
